import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionCibilContainer from "./component";
import { withRouter } from "react-router-dom";
import { submitCibilConsent, submitCibilNumber } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse
    }
}) => ({
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    submitCibilConsentConnect: submitCibilConsent,
    submitCibilNumberConnect: submitCibilNumber
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionCibilContainer));
